<template>
  <span>
    <el-popover title="状态说明" width="400" trigger="hover" placement="right-start">
      <p>1）未确认：质检数据的默认状态，暂未经过任何操作；</p>
      <p>2）已确认：质检数据已由客服进行确认，暂无异议；</p>
      <p>3）未审批：客服已对质检数据发起申诉，等待管理员审批；</p>
      <p>4）待定：质检数据的界定模糊，审批待定；</p>
      <p>5）通过：质检数据审批通过；</p>
      <p>6）驳回：驳回质检数据的申诉，审批不通过。</p>
      <i class="el-icon-question" style="cursor: pointer; width: 20px" slot="reference" placement="right"></i>
    </el-popover>
  </span>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
    };
  },
};
</script>

<style>
</style>